import {
  DeliveryManStatusEnum,
  translatedAccessControlProps,
} from 'modules/access-controls/types';
import useEditDeliveryMan, {
  EditDeliveryManProps,
} from 'modules/delivery-men/hooks/use-edit-delivery-man';
import deliveryMenKeys from 'modules/delivery-men/util/delivery-men-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditDeliveryMan: React.FC = () => {
  const {id} = useParams();
  const {getInput, getSelect, getNumberInput, getAddressInput} =
    useFormInputs<EditDeliveryManProps>();

  return (
    <Edition<EditDeliveryManProps>
      inputs={[
        getInput({
          name: 'user.name',
          disabled: true,
        }),
        getInput({
          name: 'user.email',
          disabled: true,
        }),
        getInput({
          name: 'user.phone',
          gridColumn: 6,
          mask: 'phone',
        }),
        getInput({
          name: 'user.emergencyPhone',
          gridColumn: 6,
          mask: 'phone',
        }),
        getInput({
          name: 'user.cpf',
          gridColumn: 4,
          mask: 'cpf',
        }),
        getInput({
          name: 'user.cnpj',
          gridColumn: 4,
          mask: 'cnpj',
        }),
        getInput({
          name: 'user.cnh',
          gridColumn: 4,
        }),
        getAddressInput({
          name: 'user.homeAddress',
          withSearch: false,
        }),
        getNumberInput({name: 'maxDeliveryQuantity'}),
        getSelect({
          name: 'deliveryManStatus',
          data: [
            {label: 'Offline', value: DeliveryManStatusEnum.OFFLINE},
            {label: 'Desativado', value: DeliveryManStatusEnum.DISABLED},
          ],
        }),
        getInput({
          name: 'user.pixKey',
        }),
      ]}
      detailsUrl={`/access-controls/${id}`}
      onSubmit={() => useEditDeliveryMan(id!)}
      translationKey={translatedAccessControlProps}
      queryKey={deliveryMenKeys.details(id!)}
    />
  );
};

export default EditDeliveryMan;
